import {
  WBBox,
  WBFlex,
  WBIcon,
  WBLink,
  WBLinkButton,
  WBTypography,
} from '@admiin-com/ds-web';
import { styled, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
interface Props {
  children: React.ReactNode;
  onClose: () => void;
  title: string;
}
export const SignPayLayout = (props: Props) => {
  const theme = useTheme();

  const { t } = useTranslation();
  const headerColor = theme.palette.mode === 'dark' ? 'white' : 'white';

  return (
    <Container>
      <StyledWBFlex>
        <HeaderFlex>
          <LeftToolbarFlex>
            <StyledWBLink
              onClick={() => {
                props.onClose();
              }}
            >
              <WBIcon color={headerColor} name="ArrowBack" size="small" />
              <WBTypography
                variant="body1"
                fontWeight="medium"
                noWrap
                ml={1}
                color={headerColor}
                component="div"
              >
                {t('back', { ns: 'common' })}
              </WBTypography>
            </StyledWBLink>
          </LeftToolbarFlex>
          <CenteredTypography
            variant="h5"
            fontWeight="medium"
            color={headerColor}
          >
            {props.title}
          </CenteredTypography>
          <FlexSpacer />
        </HeaderFlex>
        {props.children}
      </StyledWBFlex>
    </Container>
  );
};

const Container = styled(WBFlex)(({ theme }) => ({
  background: theme.palette.background.default,
  height: '100vh',
}));

const StyledWBFlex = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  alignItems: 'center',
  height: '100%',
  backgroundColor: theme.palette.background.default,
}));

const HeaderFlex = styled(WBFlex)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  flexDirection: 'row',
  padding: theme.spacing(3, 8),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  backgroundColor: theme.palette.mode === 'dark' ? '#151515' : '#151515',
}));
const LeftToolbarFlex = styled(WBFlex)({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
});
const StyledWBLink = styled(WBFlex)(({ theme }) => ({
  underline: 'always',
  alignContent: 'center',
  cursor: 'pointer',
  display: 'flex',
  color: theme.palette.common.black,
}));
const FlexSpacer = styled(WBBox)({
  flex: 1,
});
const CenteredTypography = styled(WBTypography)(({ theme }) => ({
  flex: 1,
  textAlign: 'center',
  marginBottom: 0,
}));

export default SignPayLayout;
